import { dataToExecData, ExecArgBase } from '../ExecArgBase.js';
/**
 * @category Contract Exec Arguments
 */
export default class ExecArgIncreaseAllowance extends ExecArgBase {
    static fromJSON(params) {
        return new ExecArgIncreaseAllowance(params);
    }
    toData() {
        const { params } = this;
        return {
            amount: params.amount,
            spender: params.spender,
            expires: params.expires,
        };
    }
    toExecData() {
        return dataToExecData('increase_allowance', this.toData());
    }
}
